var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"graficca"},[_c('h1',[_vm._v("Chart.js")]),_c('LineChart',{ref:"mychart",attrs:{"chartData":_vm.config.data,"options":_vm.config.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }